import { connect } from 'react-redux';

import { setRequestRefillModalStatus } from 'src/app/state/actions';
import type { Dispatch, RootState } from 'src/app/state/store';

import { Renderer } from '.';

const mapStateToProps = (state: RootState) => {
  const { requestRefillModalStatus } = state;

  return { requestRefillModalStatus };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  hideRequestRefillModal: () => {
    return dispatch(setRequestRefillModalStatus({ isShown: false, success: undefined }));
  },
});

export const RequestRefillModal = connect(mapStateToProps, mapDispatchToProps)(Renderer);
